<app-header></app-header>

<div class="page-title-area page-title-style-two despre-bg">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Creare cont</li>
            </ul>
            <h2>Creare cont</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h3>Creare cont C.M.D.T.A.M.P</h3>

                <span>Pentru a putea beneficia de un cont online pe portalul CMDTAMP - Centrul Medical de
                    diagnostic, tratament ambulatoriu si medicina preventiva Bucuresti , va asteptam in incinta
                    policlinicii noastre din strada Washington 8-10, la biroul Programari, cu buletinul. Ulterior,
                    veti primi din partea CMDTAMP un user si o parola pentru a avea acces in sectiunea ACCES
                    MEMBRI</span>

            </div>
        </div>
    </div>
</div>
